module.exports = __webpack_public_path__ + "static/media/Image02.f7c37b5d.png";